import { observable, action, computed, runInAction } from 'mobx';
import CoreService from 'services/Core.service';
import BlogStore from './Blog.store';
import WindowStore from './Window.store';
import NavigationStore from './Navigation.store';
import ProductsStore from './Products.store';
import CalculatorStore from './Calculator.store';
import ForInvestorsStore from './ForInvestors.store';
import GlobalMetaTagsStore from './GlobalMetaTags.store';

class CoreStore {
  @observable translations = {};

  @observable content = {};

  @observable blogContactComponent = {};

  @observable newsletterThankYouPage = {};

  initialCoreDataFetchDone = observable.box(false);

  constructor() {
    this.productsStore = new ProductsStore(this);
    this.navigationStore = new NavigationStore(this);
    this.windowStore = new WindowStore(this);
    this.calculatorStore = new CalculatorStore(this);
    this.blogStore = new BlogStore(this);
    this.forInvestorsStore = new ForInvestorsStore(this);
    this.globalMetaTagsStore = new GlobalMetaTagsStore(this);
    this.getCoreData();
  }

  @computed
  get isLoaded() {
    return this.initialCoreDataFetchDone.get();
  }

  @action
  async getCoreData() {
    try {
      const coreData = await CoreService.fetchCoreData();
      runInAction(() => {
        this.content = coreData;
        this.translations = coreData.translations;
        this.blogContactComponent = coreData.blogContactComponent;
        this.initialCoreDataFetchDone.set(true);
        this.newsletterThankYouPage = coreData.blogNewsletterThankYouPage;
      });
    } catch (err) {
      console.log('error when fetching core data: ', err);
    }
  }
}

export default CoreStore;



// WEBPACK FOOTER //
// ./src/stores/Core.store.js